var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "square",
    strokeWidth: 2,
    fill: "none",
    stroke: "#212121",
    className: "file_svg__nc-icon-wrapper",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    "data-cap": "butt",
    strokeLinecap: "butt",
    d: "M30 2v12h12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 2H6v44h36V14z"
  }))));
}

export default SvgFile;